import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

export type PaylensEmbedTokenResponse = {
    token: string;
    userId: string;
    ttlMinutes: number;
    audience: string;
    expiresAt: number;
};

const GetEmbedToken = (): Promise<PaylensEmbedTokenResponse> =>
    request({
        url: ApiURL.Query.GetEmbedToken,
        method: RequestType.GET,
    });

const PaylensQuery = {
    GetEmbedToken,
};

export default PaylensQuery;
